import { ManagersModuleBase } from "Managers/ManagersModuleBase";
import { APIManager } from "./APIManager";
import { CommandsManager } from "./CommandsManager";
import { DomainManager } from "./DomainManager";
import { MobXManager } from "./MobXManager";
import type { WeeklyRotaViewModel } from "../WeeklyRotaViewModel";

export class ManagersModule extends ManagersModuleBase<WeeklyRotaViewModel> {
    public api!: APIManager;
    public commands!: CommandsManager;
    public domain!: DomainManager;
    public mobx!: MobXManager;

    constructor(viewModel: WeeklyRotaViewModel) {
        super(viewModel);
        this.createManagers();
    }

    protected createManagers(): void {
        this.mobx = new MobXManager();
        this.api = new APIManager(this.viewModel);
        this.domain = new DomainManager(this.viewModel);
        this.commands = new CommandsManager(this.viewModel);
    }
}
